// Games Portal Types

export type GameId = 'neura-dash' | 'flappy-ellie' | 'space-ellie';

export interface GameConfig {
  id: GameId;
  name: string;
  subtitle: string;
  description: string;
  tags: string[];
  status: 'live' | 'coming-soon';
  entryUrl: string;
}

export interface ModalState {
  isOpen: boolean;
  currentGame: GameId | null;
}

// Game configurations
export const GAMES: GameConfig[] = [
  {
    id: 'neura-dash',
    name: 'Neura Dash',
    subtitle: "Ellie's Endless Run",
    description: "Ellie's endless running adventure! Jump over obstacles, collect coins, and dash your way to the top of the leaderboard.",
    tags: ['Endless Runner', 'Leaderboard', '$ELLIE Burn'],
    status: 'live',
    entryUrl: '/neura-dash.html',
  },
  {
    id: 'flappy-ellie',
    name: 'Flappy Ellie',
    subtitle: 'Tap to Fly!',
    description: 'Guide Ellie through treacherous pipes in this challenging flappy-style game. One tap controls, infinite fun!',
    tags: ['Arcade', 'One-Tap', 'High Score'],
    status: 'live',
    entryUrl: '/flappy-ellie.html',
  },
  {
    id: 'space-ellie',
    name: 'Space Ellie',
    subtitle: 'Defend the Galaxy!',
    description: 'Blast alien invaders in this classic space shooter! Move and shoot to survive waves of enemies. How long can you last?',
    tags: ['Shooter', 'Arcade', 'Waves'],
    status: 'live',
    entryUrl: '/space-ellie.html',
  },
];
